var map = {
	"./background.svg": "a762",
	"./bzk.svg": "b176",
	"./cdai.svg": "d4a1",
	"./charity.svg": "82ca",
	"./compound-dark.svg": "ab76",
	"./dai.svg": "ad60",
	"./ethberlinzwei.svg": "6c4a",
	"./logo-old.svg": "cd61",
	"./logo.svg": "9b19",
	"./metamask.svg": "d6c5",
	"./rdai-old.svg": "9580",
	"./rdai.svg": "2b3f",
	"./sai.svg": "974c",
	"./santa.svg": "bdc3",
	"./unicef-1.svg": "0cdc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";